import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { Box, Modal, Typography } from '@mui/material';
import RouteModal from '../../components/routeModal';
import SchedulesModal from '../../components/schedulesModal';
import DevicesStep from '../../components/stepperComponents/devicesStep';

const RouteStep = ({ openRouteModal, setOpenRouteModal, userRoute, userUpdate }) => {
    return <>
        <span className="material-symbols-outlined" style={{ fontSize: '8rem', marginBottom: '2rem' }}>
            edit_location_alt
        </span>
        <h3 style={{ marginBottom: '1rem', fontSize: '0.95rem' }}>
            Gestione la ruta general que seguiran las flotas vehiculares, definiendo el orden de los puntos de control y su estado ("Activo"/"Omitido"), misma que determinará el recorrido correcto para los vehículos y facilitará la administración de los mismos y de los horarios.
        </h3>
        <Button style={{ fontSize: '0.8rem' }} onClick={() => setOpenRouteModal(true)}>
            Modificar Ruta
        </Button>
        {setOpenRouteModal && <RouteModal onOpen={openRouteModal} onClose={setOpenRouteModal} userRoute={userRoute} userUpdate={userUpdate} />}
    </>;
}

const SchedulesStep = ({ devices, userSchedules, userRoute, geoTags, geofences, userUpdate, scheduleRegister, showAlert }) => {
    const checadasTag = geoTags.find((item) => item.name === 'Checadas');
    let filteredGeofences = [];
    if (checadasTag) {
        const checadasId = checadasTag.id;

        // Filtrar geofences que contengan el id de "Checadas" en sus tags
        filteredGeofences = geofences.filter(
            (geofence) => Array.isArray(geofence.tags) && geofence.tags.includes(checadasId)
        );
    }

    return <>
        <span className="material-symbols-outlined" style={{ fontSize: '8rem', marginBottom: '2rem' }}>
            calendar_clock
        </span>
        <h3 style={{ marginBottom: '1rem', fontSize: '0.95rem' }}>
            Cree horarios para que todas las flotas vehiculares puedan coordinar sus tiempos de llegada a los puntos de control definidos en la ruta y poder calcular sus estatus y diferencia de tiempo correctamente.
        </h3>
        <SchedulesModal devices={devices} userSchedules={userSchedules} userRoute={userRoute} geofences={filteredGeofences} userUpdate={userUpdate} scheduleRegister={scheduleRegister} showAlert={showAlert} />
    </>;
}

const FirstSteps = ({ open, onClose, userRoute, userUpdate, devices, userSchedules, geoTags, geofences, scheduleRegister, showAlert, updateSchedule }) => {
    const [activeStep, setActiveStep] = useState(0);
    const [openRouteModal, setOpenRouteModal] = useState(false);

    const handleNext = () => setActiveStep((prev) => prev + 1);
    const handleBack = () => setActiveStep((prev) => prev - 1);
    const handleClose = () => {
        setActiveStep(0);
        onClose();
    };

    const steps = [
        { label: 'Modificar Ruta General', content: <RouteStep openRouteModal={openRouteModal} setOpenRouteModal={setOpenRouteModal} userRoute={userRoute} userUpdate={userUpdate} /> },
        { label: 'Crear Horarios', content: <SchedulesStep devices={devices} userSchedules={userSchedules} userRoute={userRoute} geoTags={geoTags} geofences={geofences} userUpdate={userUpdate} scheduleRegister={scheduleRegister} showAlert={showAlert} /> },
        { label: 'Administrar Dispositivos', content: <DevicesStep devices={devices} userSchedules={userSchedules} userUpdate={userUpdate} updateSchedule={updateSchedule} /> },
    ];

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60vw',
        height: '80vh',
        bgcolor: 'var(--color-white)',
        boxShadow: 24,
        p: 4,
        borderRadius: 2,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <Box className="route_modal_container" sx={modalStyle}>
                {/* Título */}
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>Primeros Pasos</Typography>
                {/* Stepper */}
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((step) => (
                        <Step key={step.label}>
                            <StepLabel sx={{
                                '& span:last-child': {
                                    color: 'var(--color-dark)',
                                },
                            }}>{step.label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                {/* Contenido del paso */}
                <Box sx={{ flex: 1, mb: 3, mt: 2, padding: activeStep === 2 ? '0 50px' : '0 100px', overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    {steps[activeStep].content}
                </Box>
                {/* Botones de navegación */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button onClick={handleClose} color='error'>Cerrar</Button>
                    <Box>
                        <Button onClick={handleBack} disabled={activeStep === 0} sx={{ mr: 1 }}>
                            Anterior
                        </Button>
                        <Button
                            onClick={activeStep === steps.length - 1 ? handleClose : handleNext}
                            color="primary"
                            variant="contained"
                        >
                            {activeStep === steps.length - 1 ? 'Finalizar' : 'Siguiente'}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
};

export default FirstSteps;
